import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARTER_EXPERIENCE_SHARE_RECOMMENDATIONS = createFcmDetails(
	'starter_experience_share_recommendations',
	{
		owner: 'Starter Experience',
		context: 'Starter Petition Dashboard',
		import: false,
		description:
			'If true, the users are treated into an A/B testing experiment to show AI generated sharing recommendations',
		template: {
			isEnabled: false,
			experiment: 'starter_experience_share_recommendations_v01',
		},
		mergeLogic: 'Displays in order of country then locale',
	},
);
